import { bus_bangkiemtuanthu, BusBangKiemTuanThuItemResponse } from '../../../models/response/bus/bus_bangkiemtuanthu';

export enum eBusBangKiemTuanThuActionTypeIds {
	LOAD_START = "BUS_BANGKIEMTUANTHU_LOAD_START",
	LOAD_SUCCESS = "BUS_BANGKIEMTUANTHU_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_BANGKIEMTUANTHU_LOAD_ERROR",

	SHOW_DETAIL = "BUS_BANGKIEMTUANTHU_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_BANGKIEMTUANTHU_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_BANGKIEMTUANTHU_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_BANGKIEMTUANTHU_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_BANGKIEMTUANTHU_CLOSE_CONFIRM",

	DELETE_START = "BUS_BANGKIEMTUANTHU_DELETE_START",
	DELETE_SUCCESS = "BUS_BANGKIEMTUANTHU_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_BANGKIEMTUANTHU_DELETE_ERROR",

	SAVE_START = "BUS_BANGKIEMTUANTHU_SAVE_START",
	SAVE_SUCCESS = "BUS_BANGKIEMTUANTHU_SAVE_SUCCESS",
	SAVE_ERR = "BUS_BANGKIEMTUANTHU_SAVE_ERR"
}

export interface IBusBangKiemTuanThuLoadStart {
	type: eBusBangKiemTuanThuActionTypeIds.LOAD_START,
	payload: number
}
export interface IBusBangKiemTuanThuLoadSuccess {
	type: eBusBangKiemTuanThuActionTypeIds.LOAD_SUCCESS,
	payload: BusBangKiemTuanThuItemResponse[]
}
export interface IBusBangKiemTuanThuLoadErr {
	type: eBusBangKiemTuanThuActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusBangKiemTuanThuShowDetail {
	type: eBusBangKiemTuanThuActionTypeIds.SHOW_DETAIL,
	payload?: bus_bangkiemtuanthu
}
export interface IBusBangKiemTuanThuCloseDetail {
	type: eBusBangKiemTuanThuActionTypeIds.CLOSE_DETAIL
}
export interface IBusBangKiemTuanThuChangeSelectedIds {
	type: eBusBangKiemTuanThuActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusBangKiemTuanThuShowConfirm {
	type: eBusBangKiemTuanThuActionTypeIds.SHOW_CONFIRM
}
export interface IBusBangKiemTuanThuCloseConfirm {
	type: eBusBangKiemTuanThuActionTypeIds.CLOSE_CONFIRM
}
export interface IBusBangKiemTuanThuDeleteStart {
	type: eBusBangKiemTuanThuActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusBangKiemTuanThuDeleteSuccess {
	type: eBusBangKiemTuanThuActionTypeIds.DELETE_SUCCESS
}
export interface IBusBangKiemTuanThuDeleteErr {
	type: eBusBangKiemTuanThuActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusBangKiemTuanThuSaveStart {
	type: eBusBangKiemTuanThuActionTypeIds.SAVE_START,
	payload: bus_bangkiemtuanthu
}
export interface IBusBangKiemTuanThuSaveSuccess {
	type: eBusBangKiemTuanThuActionTypeIds.SAVE_SUCCESS
}
export interface IBusBangKiemTuanThuSaveErr {
	type: eBusBangKiemTuanThuActionTypeIds.SAVE_ERR,
	payload: string
}
export type IBusBangKiemTuanThuActionTypes = IBusBangKiemTuanThuLoadStart | IBusBangKiemTuanThuLoadSuccess | IBusBangKiemTuanThuLoadErr |
	IBusBangKiemTuanThuShowDetail | IBusBangKiemTuanThuCloseDetail |
	IBusBangKiemTuanThuChangeSelectedIds |
	IBusBangKiemTuanThuShowConfirm | IBusBangKiemTuanThuCloseConfirm |
	IBusBangKiemTuanThuDeleteStart | IBusBangKiemTuanThuDeleteSuccess | IBusBangKiemTuanThuDeleteErr |
	IBusBangKiemTuanThuSaveStart | IBusBangKiemTuanThuSaveSuccess | IBusBangKiemTuanThuSaveErr
